<template>
    <div class="row">
        <div v-if="loading" class="lds-dual-ring"></div>
        <div class="col-lg-12 mb-4" v-if="!loading">
            <div class="box">
                <div class="box-offset">
                    <div class="box-ttl-wrap mb-2">
                        <div class="box-ttl">History</div>
                    </div>
                    <div class="buttons--row buttons--row-2 mb-3">
                        <div class="search--block">
                            <button
                                class="search--block-btn"
                                type="submit"
                                @click="getRequestHistory"
                            ><img src="/img/svg/icons-search.svg" alt=""></button>
                            <input
                                type="search"
                                class="search--block-txt"
                                placeholder="Search by Name"
                                v-model="filters.search_name"
                                @input="handleSearch"
                            />
                        </div>
                        <div class="search--block">
                            <button
                                class="search--block-btn"
                                type="submit"
                                @click="getRequestHistory"
                            ><img src="/img/svg/icons-search.svg" alt=""></button>
                            <input
                                type="search"
                                class="search--block-txt"
                                placeholder="Search by Item"
                                v-model="filters.search_item"
                                @input="handleSearch"
                            />
                        </div>
                        <div class="filter-wrap">
                            <label for="" class="reg-label mr-2">Filter:</label>
                            <div class="form-group form-group-2 mb-0">
                                <select
                                    class="custom-select"
                                    v-model="filters.status"
                                    @change.prevent="getRequestHistory"
                                >
                                    <option value="all">Select One</option>
                                    <option
                                        v-for="status in statusList"
                                        :key="status.id"
                                        :value="status.id"
                                    >
                                        {{ status.title }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="table-holder table-responsive table-height">
                        <table class="table table-uniform">
                            <thead>
                            <tr>
                                <th>
                                    Request ID
                                </th>
                                <th>
                                    Employee Name
                                </th>
                                <th>
                                    Item
                                </th>
                                <th class="text-center">
                                    Admin Name
                                </th>
                                <th class="text-center">
                                    Date of Change
                                </th>
                                <th>
                                    Original Status
                                </th>
                                <th >Change Status</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="item in requestHistory"
                                :key="item.id">
                                <td>
                                    <div class="action-list">
                                        <a class="action-link dropdown-toggle" data-toggle="dropdown" href="#">
                                           {{item.request_id}}
                                        </a>
                                        <div class="dropdown-menu">
                                            <ul class="drop-list">
                                                <li>
                                                    <div><b> Location:</b></div>
                                                    <div>
                                                        {{item.request.address}}
                                                    </div>
                                                </li>
                                                <li>
                                                    <div><b>
                                                        Date:</b></div>
                                                    <div>
                                                     {{calculateDate(item.request.created_at)}}
                                                    </div>
                                                </li>
                                                <li>
                                                    <div><b>
                                                        Size:</b></div>
                                                    <div>
                                                        {{item.request.size}}
                                                    </div>
                                                </li>
                                                <li>
                                                    <div><b>
                                                        Quantity:</b></div>
                                                    <div>
                                                        {{item.request.quantity}}
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <b>{{item.request.employee.name ?? ''}} {{item.request.employee.last_name?? ''}}</b>
                                </td>
                                <td>
                                    {{item.request.uniform.title}}
                                </td>
                                <td class="text-center">
                                    <b>{{item.admin.name ?? ''}} {{item.admin.last_name ?? ''}}</b>
                                </td>
                                <td class="text-center">
                                    <div class="color--gray">{{calculateDate(item.created_at)}}</div>
                                </td>
                                <td >
                                    {{item.original_status.title}}
                                </td>
                                <td >
                                    {{item.current_status.title}}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <Pagination
                        :currentPage="pagination.current_page"
                        :lastPage="pagination.last_page"
                        @changeItemsPerPage="changeItemsPerPage"
                        @changePage="changePage" />
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import UniformsService from "./service/UniformsService";
import Pagination from "../../../../../resources/js/components/Pagination.vue";
import PaginationHandler from "../../../../../resources/js/mixins/PaginationHandler";
import DateConverter from "../../../../../resources/js/mixins/DateConverter";
import {createDebouncedFunction} from "../../../../../resources/js/plugins/debounce";

export default {
    name: 'UniformRequestsHistory',
    components: {Pagination},
    mixins: [PaginationHandler, DateConverter],
    data() {
        return {
            loading: true,
            requestHistory: [],
            statusList: [],
            filters: {
                search_name: '',
                search_item: '',
                search_size: '',
                status: 'all',
                sortBy: 'size',
                sortDir: 'asc',
                page: 1,
                perPage: 10
            },
            pagination: {
                current_page: 1,
                last_page: 1,
            },
        }
    },
    methods: {
        getList(filters) {
            this.getRequestHistory(filters)
        },
        async getStatusList() {
            try {
                const {data: statuses} = await UniformsService.getStatusList()
                this.statusList = statuses
            } catch (e) {
                this.$showErrorMessage();
            }
        },
        async getRequestHistory() {
            try {
                const {data: history} = await UniformsService.getHistory(this.filters)
                this.requestHistory = history.data
                this.pagination.current_page = history.current_page
                this.pagination.last_page = history.last_page
                this.loading = false
            } catch (e) {
                this.$showErrorMessage()
            }
        },
        handleSearch() {
            this.filters.page = 1
            this.delayedSearch();
        },
    },
    mounted() {
        this.getRequestHistory();
        this.getStatusList();
        this.delayedSearch = createDebouncedFunction(() => this.getRequestHistory(), 500);
    }
}

</script>

<style scoped>

</style>
